<script lang="ts">
    import {guiCreatorDataStore} from "../../../stores/guiCreatorData";
    import {parseDataToSaveConfig, parseRawData} from '../../../services/storage.service';
    import {GUICreatorData} from '../../../stores/types';
    import {inputFocusedStore} from '../../../stores/inputFocus';
    import {genCode} from '../../../code-generator/codeGenerator';
    import {saveAs} from 'file-saver';

    let isProjectNameMissing = false;
    let fileOverDropZone = false;
    let inputErrorClasses = '';

    let projectName = 'Banglejs GUI'

    guiCreatorDataStore.subscribe((storeGuiCreatorData) => {
        projectName = storeGuiCreatorData.projectName;
    })

    function generateCode() {
        return genCode(guiCreatorDataStore.get());
    }

    function onCodeDownload() {
        const generatedCode = generateCode();

        const blob = new Blob([generatedCode],
            {type: "text/javascript;charset=utf-8"});
        const parsedProjectName = projectName.replace(/\s+$/, '').replace(/\s+/g, '-');
        saveAs(blob, `${parsedProjectName}.js`);

    }

    function onCodeCopy() {
        const generatedCode = generateCode();
        navigator.clipboard.writeText(generatedCode);
        console.info(`Generated code was added to clipboard`);
    }

    function onProjectNameUpdate(newProjectName) {
        guiCreatorDataStore.updateProjectName(newProjectName);
    }

    function onSaveConfigs() {

        const generatedCode = parseDataToSaveConfig(guiCreatorDataStore.get());
        const blob = new Blob([JSON.stringify(generatedCode, null, 2)],
            {type: "text/json;charset=utf-8"});
        const date = new Date();
        const dateString = `${date.getDate()}-${date.getUTCMonth() + 1}-${date.getUTCFullYear()}_${date.getHours()}-${date.getMinutes()}`;
        const parsedProjectName = projectName.replace(/\s+$/, '').replace(/\s+/g, '-');

        saveAs(blob, `${parsedProjectName}-config-${dateString}.json`);
    }

    function onConfigCopy() {
        const generatedCode = parseDataToSaveConfig(guiCreatorDataStore.get());
        navigator.clipboard.writeText(JSON.stringify(generatedCode, null, 2));
        console.info(`Generated code was added to clipboard`);
    }

    async function dropHandler(ev) {
        ev.preventDefault();
        if (ev.dataTransfer.items) {
            if (ev.dataTransfer.items.length > 1) {
                console.warn('More then one file detected, only first file will be used');
            }
            const file = ev.dataTransfer.items[0].getAsFile();
            const text = await file.text();
            let data: GUICreatorData;
            try {
                data = parseRawData(text);
            } catch (e) {
                console.error('Can not parse input file: ', e);
                console.error('Abort importing file');
                return;
            }
            guiCreatorDataStore.set(data);
        } else {
            console.warn(`Data import not implemented`)
        }
    }

    function onProjectNameChange() {
        isProjectNameMissing = !projectName || projectName.length === 0;
        if (isProjectNameMissing) {
            inputErrorClasses = 'input-bordered input-error'
        } else {
            inputErrorClasses = '';
        }
        if (!isProjectNameMissing) {
            onProjectNameUpdate(projectName);
        }

    }

    function dragOverHandler(ev) {
        ev.preventDefault();
        fileOverDropZone = true;
    }

    function onDragLeave(ev) {
        ev.preventDefault();

        fileOverDropZone = false;
    }

    function onFocus() {
        inputFocusedStore.set(true);
    }

    function onBlur() {
        onProjectNameChange();
        inputFocusedStore.set(false);
    }

</script>

<div>
    <div class="py-4">
        <label>Project name</label>
        <input type="text" placeholder="Project name" on:blur={onBlur} on:focus={onFocus}
               on:keyup="{onProjectNameChange}"
               bind:value={projectName}
               class={'text-center input input-xs input-ghost w-full ' + inputErrorClasses} required/>
    </div>
    <button class="btn" on:click={onCodeDownload}>Generate Code</button>
    <button class="btn" on:click={onCodeCopy}>Copy code to clipboard</button>
    <button class="btn" on:click={onSaveConfigs}>Save configs</button>
    <button class="btn" on:click={onConfigCopy}>Copy configs to clipboard</button>
    <div id="drop_zone"
         class="border border-dashed border-2 { fileOverDropZone ? 'border-blue-400' : 'border-gray-300'} "
         style="height: 100px;"
         on:drop={dropHandler}
         on:dragover={dragOverHandler}
         on:dragleave={onDragLeave}>
        <p>Drag and drop to import</p>
        <p>bangle ui configurations.</p>
    </div>
</div>
